module.exports = __webpack_public_path__ + "static/img/stay-up-to-date-1.576a84a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stay-up-to-date-1.jpg
// module id = VWfS
// module chunks = 0